module.exports = __webpack_public_path__ + "static/portfolio01.6d5e9ec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio01.jpg
// module id = 456
// module chunks = 114276838955818